import { Provider, Type } from '@angular/core';
import { Store } from '@ngrx/store';
import { GridDataSourceServerSideService } from './data-source.serverside.service';
import {
  DATA_GRID_CURRENT_ACCESS_SERVICE,
  DATA_GRID_DATA_SOURCES,
  DATA_GRID_FILTER_SERVICE,
  DATA_GRID_READER_SERVICE,
  DATA_GRID_SERVICES,
} from './injection-tokens';
import { GridDataSources, GridFilterService, ReaderService, UserAccessService } from './types';
import { GridServerSideService } from './grid.serverside.service';
import { GridInfiniteService } from './grid.infinite.service';
import { GridDataSourceInfiniteService } from './data-source.infinite.service';

export const provideDataGrid = <DataModel, ReadConfig>(
  dataSource: Type<GridDataSources<DataModel, ReadConfig>>,
  filterService: Type<GridFilterService<DataModel>>,
  readerService: Type<ReaderService<DataModel>>,
  options: {
    currenAccessService?: Type<UserAccessService>;
    featureStores?: Type<unknown>[];
    datasourceSide?: 'server' | 'infinite';
  } = { datasourceSide: 'server' },
): Provider[] => [
  Store,
  ...(options?.featureStores ?? []),
  options.datasourceSide === 'server'
    ? GridDataSourceServerSideService<DataModel>
    : GridDataSourceInfiniteService<DataModel>,
  {
    provide: DATA_GRID_SERVICES,
    useClass: options.datasourceSide === 'server' ? GridServerSideService<DataModel> : GridInfiniteService<DataModel>,
  },
  { provide: DATA_GRID_DATA_SOURCES, useClass: dataSource },
  { provide: DATA_GRID_FILTER_SERVICE, useClass: filterService },
  { provide: DATA_GRID_READER_SERVICE, useClass: readerService },
  {
    provide: DATA_GRID_CURRENT_ACCESS_SERVICE,
    ...(options?.currenAccessService
      ? {
          useClass: options?.currenAccessService,
        }
      : {
          useValue: undefined,
        }),
  },
];
